import { render, staticRenderFns } from "./BookMakingAppointmentDentist.vue?vue&type=template&id=9cccd6fc&scoped=true&"
import script from "./BookMakingAppointmentDentist.vue?vue&type=script&lang=js&"
export * from "./BookMakingAppointmentDentist.vue?vue&type=script&lang=js&"
import style0 from "./BookMakingAppointmentDentist.vue?vue&type=style&index=0&id=9cccd6fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cccd6fc",
  null
  
)

export default component.exports